import { cn } from '@/lib/utils'
import { type SalesLeadStatus, salesLeadStatusColors, salesLeadStatusLabels } from '@/models/salesLead'

interface StatusChipProps {
  status: SalesLeadStatus
  className?: string
}

/** A lead status in its pipeline colour. */
export function StatusChip({ status, className }: StatusChipProps) {
  return (
    <span
      className={cn('rounded px-1.5 py-0.5 text-xs font-medium', salesLeadStatusColors[status], className)}
    >
      {salesLeadStatusLabels[status]}
    </span>
  )
}
